export default function AppLogoPreview() {
  const apps = [
    { src: '/logo-giraffe.png', name: 'Giraffe',     bg: '#0A1F0F' },
    { src: '/logo-uncode.png',  name: 'Uncode',      bg: '#1A0A05' },
    { src: '/logo-512.png',     name: 'Zephyr OS',    bg: '#0a0a0f' },
    { src: '/logo-zephyr.png',  name: 'Zephyr',      bg: '#12031A' },
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: '#111',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 64,
      padding: '80px 40px',
      fontFamily: 'system-ui, sans-serif',
    }}>

      {/* SVG squircle definition */}
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <clipPath id="squircle-preview" clipPathUnits="objectBoundingBox">
            <path d="M 1 0.5 C 1 0.955 0.955 1 0.5 1 C 0.045 1 0 0.955 0 0.5 C 0 0.045 0.045 0 0.5 0 C 0.955 0 1 0.045 1 0.5 Z" />
          </clipPath>
        </defs>
      </svg>

      <p style={{ color: 'rgba(255,255,255,0.2)', fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', margin: 0 }}>
        App Logo Preview
      </p>

      {/* Row of icons */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 48,
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {apps.map(({ src, name, bg }) => (
          <div key={name} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
            {/* App icon — 180px = Apple standard iPhone icon size */}
            <div style={{
              width: 180,
              height: 180,
              clipPath: 'url(#squircle-preview)',
              background: bg,
              overflow: 'hidden',
              flexShrink: 0,
            }}>
              <img
                src={src}
                alt={name}
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              />
            </div>
            <span style={{
              color: 'rgba(255,255,255,0.35)',
              fontSize: 12,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              fontWeight: 300,
            }}>
              {name}
            </span>
          </div>
        ))}
      </div>

      {/* Larger 256px comparison */}
      <p style={{ color: 'rgba(255,255,255,0.15)', fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', margin: 0, marginTop: 32 }}>
        256 px
      </p>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 48,
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {apps.map(({ src, name, bg }) => (
          <div key={name + '-lg'} style={{
            width: 256,
            height: 256,
            clipPath: 'url(#squircle-preview)',
            background: bg,
            overflow: 'hidden',
            flexShrink: 0,
          }}>
            <img
              src={src}
              alt={name}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </div>
        ))}
      </div>

    </div>
  );
}
